import { useMutation } from '@tanstack/react-query';
import { startPractice } from '../queries/post';

export function useStartPractice() {
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['startPractice'], 
    mutationFn: () => startPractice(),
    retry: false
  });

  return { mutate, data, isPending };
}
